module.exports = __webpack_public_path__ + "assets/img/16_1805.e8f236bb.jpg";